import React from 'react';
import { Card } from 'antd';
import { UserOutlined, BankOutlined } from '@ant-design/icons';
import { useSignUp } from '../context/SignUpContext';
import StepNavigation from '../components/StepNavigation';

const StepAccountType = () => {
  const { formData, updateField, nextStep, prevStep } = useSignUp();

  const handleSelect = (type) => {
    updateField('accountType', type);
  };

  const handleNext = () => {
    if (formData.accountType) {
      nextStep();
    }
  };

  return (
    <div className="step-content">
      <div className="step-header">
        <h2>Tipo de conta</h2>
        <p>Selecione o tipo de conta que melhor representa seu negócio.</p>
      </div>

      <div className="account-type-cards">
        <Card
          className={`account-type-card ${formData.accountType === 'SELLER_PF' ? 'selected' : ''}`}
          onClick={() => handleSelect('SELLER_PF')}
          hoverable
        >
          <div className="card-icon">
            <UserOutlined />
          </div>
          <h3>Pessoa Física</h3>
          <p>Para profissionais autônomos e MEIs que trabalham com CPF.</p>
          <ul>
            <li>Cadastro simplificado</li>
            <li>Receba com seu CPF</li>
            <li>Ideal para autônomos</li>
          </ul>
        </Card>

        <Card
          className={`account-type-card ${formData.accountType === 'SELLER_PJ' ? 'selected' : ''}`}
          onClick={() => handleSelect('SELLER_PJ')}
          hoverable
        >
          <div className="card-icon">
            <BankOutlined />
          </div>
          <h3>Pessoa Jurídica</h3>
          <p>Para empresas que possuem CNPJ ativo.</p>
          <ul>
            <li>Cadastro com dados da empresa</li>
            <li>Receba com seu CNPJ</li>
            <li>Ideal para empresas</li>
          </ul>
        </Card>
      </div>

      <StepNavigation
        onNext={handleNext}
        onBack={prevStep}
        showBack={false}
        nextDisabled={!formData.accountType}
      />
    </div>
  );
};

export default StepAccountType;
